import { render, staticRenderFns } from "./AcceptanceCriteria.vue?vue&type=template&id=4fa1ace2&"
import script from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"
export * from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports